export const GET_SELECT_DATA_SET_OPTIONS = "GET_SELECT_DATA_SET_OPTIONS";
export const GET_SELECT_DATA_SET_OPTIONS_SUCCESS =
  "GET_SELECT_DATA_SET_OPTIONS_SUCCESS";

export const SET_SELECT_DATA_SET_OPTIONS_LOADING =
  "SET_SELECT_DATA_SET_OPTIONS_LOADING";
